<dx-popup
  [width]="1200"
  [height]="'auto'"
  [maxHeight]="500"
  [minHeight]="700"
  [showTitle]="true"
  [title]="'MANAGE-ELEARNING.OVERVIEW.MERGE-ELERNINGS' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="dismiss()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    <div class="modal-text">
      <p>{{ "MANAGE-ELEARNING.OVERVIEW.MERGE-ELERNINGS-TEXT1" | translate }}</p>
      <p>{{ "MANAGE-ELEARNING.OVERVIEW.MERGE-ELERNINGS-TEXT2" | translate }}</p>
    </div>
    <app-table
      class="merge-table"
      [data]="elernings"
      [columns]="elerningColumns"
      [showSelection]="true"
      selectionMode="single"
      [showSearch]="false"
      (selectHandler)="onElerningSelected($event)"
    ></app-table>
    <div class="modal-buttons">
      <dx-button
        class="cta-btn"
        type="default"
        [text]="'COMMON.CANCEL' | translate"
        (click)="dismiss()"
      ></dx-button>
      <dx-button
        class="cta-btn"
        type="normal"
        [disabled]="!selectedElerningId"
        [text]="'MANAGE-ELEARNING.OVERVIEW.MERGE-NOW' | translate"
        (click)="onSubmit()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
